<!-- @format -->

<template>
    <div
        v-bind="$attrs"
        class="gst-room-amenities-modal d-flex flex-column overflow-y-hidden"
        color="text">
        <HeaderVariant1
            class="flex-grow-0 gst-room-amenities-modal__header"
            :title="$t('_common:entities.roomAmenities.roomAmenitiesModal.title')"
            @close="$emit('close')" />
        <div class="gst-room-amenities-modal__content pa-6 overflow-y-auto overflow-x-hidden">
            <span
                v-for="(amenity, k) in amenities"
                :key="k"
                class="gst-room-amenities-modal__amenity d-inline-block">
                {{ amenity }}
            </span>
        </div>
    </div>
</template>
<script>
import HeaderVariant1 from '@tenant/app/components/modals/HeaderVariant1';

export default {
    name: 'HotelRoomAmenitiesModal',
    components: {
        HeaderVariant1,
    },
    props: {
        amenities: {
            type: Array,
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-room-amenities-modal {
    background-color: theme-color('white');
}

.gst-room-amenities-modal__amenity {
    padding: theme-spacing(1);
    margin: theme-spacing(1, 1, 0, 0);
    background-color: theme-color('background-success');
    color: theme-color('success');
    border-radius: 4px;
}
</style>
